import { ExperienceItemIds } from '@consts';

export const getBlockState = (id: ExperienceItemIds): boolean =>
  id !== ExperienceItemIds.non_exist;
